import { TableRowProps, TableRowStyleProps } from '../../../types/molecules/tableRow.types'
import { boxShadow, color, display } from 'styled-system'
import styled from 'styled-components'

type TableRowBaseProps = TableRowProps & TableRowStyleProps

export const TableRowBase = styled.tr<TableRowBaseProps>`
  cursor: ${({ cursor }) => cursor || 'inherit'};
  border-bottom: 1px solid #dadcdd;
  ${({ theme, base, noHoverHighlight }) =>
    !noHoverHighlight &&
    `
    :focus,
    :hover,
    :active {
      background-color: ${base === 'thead' ? 'inherit' : theme.colors.secondary.backgroundDark};}
  `}
  ${display}
  ${boxShadow}
  ${color}
`
